var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',[_c('h1',{staticClass:"grey--text text--darken-2"},[_vm._v(" You searched for: "),_c('span',{staticClass:"blue--text font-weight-bold"},[_vm._v(_vm._s(_vm.searchTerm))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }